import type {Item} from '@PosterWhiteboard/items/item/item.class';

const STEP_INTERVAL_MS = 500;
const CYCLE_STEPS = 9;

const loadingItems = new Set<Item>();
let rafId: number | null = null;
let step = 0;
let lastStepTime = 0;

export const getLoadingPhase = (): number => {
  return (step % CYCLE_STEPS) / CYCLE_STEPS;
};

const tick = (time: number): void => {
  if (time - lastStepTime >= STEP_INTERVAL_MS) {
    lastStepTime = time;
    step += 1;
    loadingItems.forEach((item) => {
      item.renderDecorations.invalidate();
    });
  }
  rafId = requestAnimationFrame(tick);
};

export const registerLoadingItem = (item: Item): void => {
  loadingItems.add(item);
  rafId ??= requestAnimationFrame(tick);
};

export const deregisterLoadingItem = (item: Item): void => {
  loadingItems.delete(item);
  if (loadingItems.size === 0 && rafId !== null) {
    cancelAnimationFrame(rafId);
    rafId = null;
  }
};
